import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
  Switch,
  FormControlLabel,
  IconButton,
} from "@material-ui/core";
import { Delete, Add } from "@material-ui/icons";
import { toast } from "react-toastify";
import api from "../../services/api";

const PROVEDORES = [
  {
    v: "openai",
    t: "OpenAI (GPT)",
    modelos: [
      "gpt-5.6-sol",
      "gpt-5.6-terra",
      "gpt-5.6-luna",
      "gpt-5.5",
      "gpt-5.5-pro",
      "gpt-5.4",
      "gpt-5.4-pro",
      "gpt-5.4-mini",
      "gpt-5.4-nano",
      "gpt-5.2",
      "gpt-5.2-pro",
      "gpt-5",
      "gpt-5-mini",
      "gpt-5-nano",
      "gpt-4.1",
      "gpt-4.1-mini",
      "gpt-4.1-nano",
      "gpt-4o",
      "gpt-4o-mini",
    ],
    ajuda: "Pegue a chave em platform.openai.com/api-keys",
    docs: "platform.openai.com/docs/models",
  },
  {
    v: "gemini",
    t: "Google (Gemini)",
    modelos: [
      "gemini-3-flash",
      "gemini-3.5-flash",
      "gemini-3.1-pro",
      "gemini-3.1-flash-lite",
      "gemini-2.5-pro",
      "gemini-2.5-flash",
      "gemini-2.5-flash-lite",
      "gemini-2.0-flash",
    ],
    ajuda: "Pegue a chave em aistudio.google.com/apikey",
    docs: "ai.google.dev/gemini-api/docs/models",
  },
  {
    v: "anthropic",
    t: "Anthropic (Claude)",
    modelos: [
      "claude-opus-5",
      "claude-sonnet-5",
      "claude-fable-5",
      "claude-haiku-4-5-20251001",
    ],
    ajuda: "Pegue a chave em console.anthropic.com",
    docs: "docs.anthropic.com/en/docs/about-claude/models",
  },
  {
    v: "openrouter",
    t: "OpenRouter (centenas de modelos)",
    modelos: [
      "openai/gpt-5.4-mini",
      "openai/gpt-4.1",
      "anthropic/claude-sonnet-5",
      "anthropic/claude-haiku-4.5",
      "google/gemini-3-flash",
      "meta-llama/llama-3.3-70b-instruct",
      "deepseek/deepseek-chat",
      "qwen/qwen-2.5-72b-instruct",
    ],
    ajuda: "Pegue a chave em openrouter.ai/keys",
    docs: "openrouter.ai/models",
  },
];

const OUTRO = "__outro__";

const FlowBuilderAiBlockModal = ({ open, onSave, onUpdate, data, close, flowNodes }) => {
  const [activeModal, setActiveModal] = useState(false);
  const [provider, setProvider] = useState("openai");
  const [apiKey, setApiKey] = useState("");
  const [chaveSalva, setChaveSalva] = useState(false);
  const [salvandoChave, setSalvandoChave] = useState(false);
  const [model, setModel] = useState("gpt-4o-mini");
  const [modeloCustom, setModeloCustom] = useState(false);
  const [systemPrompt, setSystemPrompt] = useState("");
  const [userMessage, setUserMessage] = useState("{{resposta}}");
  const [answerKey, setAnswerKey] = useState("ai.response");
  const [autoSend, setAutoSend] = useState(false);
  const [keepContext, setKeepContext] = useState(false);
  const [contextSize, setContextSize] = useState(5);
  const [entenderAudio, setEntenderAudio] = useState(false);
  const [entenderImagem, setEntenderImagem] = useState(false);
  const [entenderPdf, setEntenderPdf] = useState(false);
  const [identificarComprovante, setIdentificarComprovante] = useState(false);
  const [smartConditions, setSmartConditions] = useState([]);
  const [defaultOutput, setDefaultOutput] = useState("padrao");

  const prov = PROVEDORES.find((p) => p.v === provider) || PROVEDORES[0];

  const varsDoFluxo = (Array.isArray(flowNodes) ? flowNodes : [])
    .map((n) => {
      const d = n?.data || {};
      return (
        d?.variableConfig?.variableName ||
        d?.answerKey ||
        d?.data?.answerKey ||
        d?.typebotIntegration?.answerKey
      );
    })
    .filter((v, i, arr) => v && arr.indexOf(v) === i);

  useEffect(() => {
    if (open === "edit") {
      const d = data?.data || data || {};
      setProvider(d.provider || "openai");
      setApiKey(d.apiKey || "");
      buscarChaveSalva(d.provider || "openai", !d.apiKey);
      const mSalvo = d.model || "gpt-4o-mini";
      setModel(mSalvo);
      const pSalvo = PROVEDORES.find((p) => p.v === (d.provider || "openai"));
      setModeloCustom(!!(pSalvo && !pSalvo.modelos.includes(mSalvo)));
      setSystemPrompt(d.systemPrompt || "");
      setUserMessage(d.userMessage || "{{resposta}}");
      setAnswerKey(d.answerKey || "ai.response");
      setAutoSend(!!d.autoSend);
      setKeepContext(!!d.keepContext);
      setContextSize(Number(d.contextSize) || 5);
      setEntenderAudio(!!d.entenderAudio);
      setEntenderImagem(!!d.entenderImagem);
      setEntenderPdf(!!d.entenderPdf);
      setIdentificarComprovante(!!d.identificarComprovante);
      setSmartConditions(Array.isArray(d.smartConditions) ? d.smartConditions : []);
      setDefaultOutput(d.defaultOutput || "padrao");
      setActiveModal(true);
    } else if (open === "create") {
      setProvider("openai");
      setApiKey("");
      buscarChaveSalva("openai", true);
      setModel("gpt-4o-mini");
      setModeloCustom(false);
      setSystemPrompt("");
      setUserMessage("{{resposta}}");
      setAnswerKey("ai.response");
      setAutoSend(false);
      setKeepContext(false);
      setContextSize(5);
      setEntenderAudio(false);
      setEntenderImagem(false);
      setEntenderPdf(false);
      setIdentificarComprovante(false);
      setSmartConditions([]);
      setDefaultOutput("padrao");
      setActiveModal(true);
    }
  }, [open, data]);

  // A chave fica guardada por provedor nas configurações da empresa, para não
  // precisar digitar de novo a cada bloco de IA criado.
  const chaveDoProvedor = (p) => `aiBlockKey_${p}`;

  const buscarChaveSalva = async (p, preencher) => {
    try {
      const { data } = await api.get(`/settings/${chaveDoProvedor(p)}`);
      const valor = data?.value || "";
      setChaveSalva(!!valor);
      if (valor && preencher) setApiKey(valor);
      return valor;
    } catch (e) {
      setChaveSalva(false);
      return "";
    }
  };

  const salvarChave = async () => {
    const v = String(apiKey || "").trim();
    if (!v) {
      toast.error("Informe a chave antes de salvar.");
      return;
    }
    setSalvandoChave(true);
    try {
      await api.put(`/settings/${chaveDoProvedor(provider)}`, { value: v });
      setChaveSalva(true);
      toast.success("Chave salva. Os próximos blocos já vêm com ela preenchida.");
    } catch (e) {
      toast.error(
        e?.response?.data?.error === "ERR_NO_PERMISSION"
          ? "Só o administrador da conta pode salvar a chave."
          : "Não foi possível salvar a chave."
      );
    }
    setSalvandoChave(false);
  };

  const esquecerChave = async () => {
    try {
      await api.put(`/settings/${chaveDoProvedor(provider)}`, { value: "" });
      setChaveSalva(false);
      toast.info("Chave removida das configurações.");
    } catch (e) {
      toast.error("Não foi possível remover a chave.");
    }
  };

  const trocarProvedor = (v) => {
    setProvider(v);
    const p = PROVEDORES.find((x) => x.v === v);
    if (p) setModel(p.modelos[0]);
    setModeloCustom(false);
    setApiKey("");
    buscarChaveSalva(v, true);
  };

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    if (!String(apiKey).trim()) {
      toast.error("Informe a chave da API.");
      return;
    }
    if (!String(model).trim()) {
      toast.error("Informe o modelo.");
      return;
    }
    if (smartConditions.length && !String(defaultOutput).trim()) {
      toast.error("Preencha o nome da saída padrão.");
      return;
    }
    for (const c of smartConditions) {
      if (!c.output || !c.output.trim()) {
        toast.error("Preencha o nome da saída em todas as condicionais.");
        return;
      }
    }
    const payload = {
      provider,
      apiKey,
      model,
      systemPrompt,
      userMessage,
      answerKey: (answerKey || "ai.response").trim(),
      autoSend,
      keepContext,
      contextSize: Number(contextSize) || 5,
      entenderAudio,
      entenderImagem,
      entenderPdf,
      identificarComprovante,
      smartConditions: smartConditions.filter((c) => c.output && c.output.trim()),
      defaultOutput: (defaultOutput || "padrao").trim(),
    };
    if (open === "edit") {
      onUpdate({ ...data, data: { ...(data?.data || {}), ...payload } });
    } else {
      onSave(payload);
    }
    handleClose();
  };

  const dica = { fontSize: 11, color: "#6b7280", display: "block", marginTop: 4, lineHeight: 1.5 };
  const caixa = { border: "1px solid #e5e7eb", borderRadius: 10, padding: 14, marginBottom: 12 };

  return (
    <Dialog open={activeModal} onClose={handleClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>{open === "create" ? "Adicionar bloco de IA" : "Editar bloco de IA"}</DialogTitle>
      <DialogContent dividers>
        <Box style={caixa}>
          <TextField
            select
            label="Provedor de IA"
            value={provider}
            onChange={(e) => trocarProvedor(e.target.value)}
            fullWidth
            size="small"
            variant="outlined"
          >
            {PROVEDORES.map((p) => (
              <MenuItem key={p.v} value={p.v}>
                {p.t}
              </MenuItem>
            ))}
          </TextField>
          <Typography style={dica}>{prov.ajuda}</Typography>

          <TextField
            label="Chave da API"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            fullWidth
            size="small"
            variant="outlined"
            type="password"
            style={{ marginTop: 14 }}
          />
          <Box style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "center" }}>
            <Button
              size="small"
              variant="outlined"
              onClick={salvarChave}
              disabled={salvandoChave}
              style={{ textTransform: "none", fontSize: 12 }}
            >
              {salvandoChave ? "Salvando..." : "Salvar chave para os próximos blocos"}
            </Button>
            {chaveSalva && (
              <Button
                size="small"
                onClick={esquecerChave}
                style={{ textTransform: "none", fontSize: 12, color: "#b45309" }}
              >
                Esquecer
              </Button>
            )}
          </Box>
          <Typography style={dica}>
            {chaveSalva
              ? "Há uma chave guardada para este provedor — os novos blocos de IA já vêm com ela preenchida."
              : "Salve a chave e ela vem preenchida automaticamente nos próximos blocos deste provedor."}{" "}
            O consumo é cobrado direto pelo provedor, não pela plataforma.
          </Typography>

          <TextField
            select
            label="Modelo"
            value={modeloCustom ? OUTRO : model}
            onChange={(e) => {
              if (e.target.value === OUTRO) {
                setModeloCustom(true);
                setModel("");
              } else {
                setModeloCustom(false);
                setModel(e.target.value);
              }
            }}
            fullWidth
            size="small"
            variant="outlined"
            style={{ marginTop: 14 }}
          >
            {prov.modelos.map((m) => (
              <MenuItem key={m} value={m}>
                {m}
              </MenuItem>
            ))}
            <MenuItem value={OUTRO}>Outro (digitar o nome)</MenuItem>
          </TextField>

          {modeloCustom && (
            <TextField
              label="Nome do modelo"
              value={model}
              onChange={(e) => setModel(e.target.value)}
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginTop: 8 }}
              placeholder={prov.modelos[0]}
              helperText={`Escreva exatamente como está em ${prov.docs}`}
            />
          )}
          <Typography style={dica}>
            Lançam modelos novos toda hora — se o que você quer não estiver na lista,
            escolha <b>Outro</b> e digite o nome. Se o modelo não estiver liberado na sua
            chave, a execução falha e o motivo fica em <b>{"{{ai.error}}"}</b>.
          </Typography>
        </Box>

        <Box style={caixa}>
          <TextField
            label="Mensagem enviada à IA"
            value={userMessage}
            onChange={(e) => setUserMessage(e.target.value)}
            fullWidth
            multiline
            minRows={2}
            size="small"
            variant="outlined"
          />
          <Typography style={dica}>
            É o que a IA vai receber para responder. O padrão <b>{"{{resposta}}"}</b> envia
            o que o cliente acabou de mandar.
          </Typography>

          <Box style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
            {["resposta", "nome", "numero"].map((v) => (
              <Button
                key={v}
                size="small"
                variant="outlined"
                onClick={() => setUserMessage((o) => `${o}{{${v}}}`)}
                style={{ textTransform: "none", fontSize: 11 }}
              >
                {`{{${v}}}`}
              </Button>
            ))}
            {varsDoFluxo.map((v) => (
              <Button
                key={`f-${v}`}
                size="small"
                variant="outlined"
                onClick={() => setUserMessage((o) => `${o}{{${v}}}`)}
                style={{ textTransform: "none", fontSize: 11, borderColor: "#a5b4fc", color: "#4f46e5" }}
              >
                {`{{${v}}}`}
              </Button>
            ))}
          </Box>

          <TextField
            label="Salvar resposta da IA em"
            value={answerKey}
            onChange={(e) => setAnswerKey(e.target.value)}
            fullWidth
            size="small"
            variant="outlined"
            style={{ marginTop: 14 }}
          />
          <Typography style={dica}>
            Use nos próximos blocos como <b>{`{{${answerKey || "ai.response"}}}`}</b>. A resposta
            também fica sempre em <b>{"{{ai.response}}"}</b>.
          </Typography>

          <FormControlLabel
            style={{ marginTop: 8 }}
            control={
              <Switch checked={autoSend} onChange={(e) => setAutoSend(e.target.checked)} color="primary" />
            }
            label={<span style={{ fontSize: 13 }}>Enviar a resposta da IA ao cliente automaticamente</span>}
          />
        </Box>

        <Box style={caixa}>
          <TextField
            label="Comportamento da IA (prompt)"
            value={systemPrompt}
            onChange={(e) => setSystemPrompt(e.target.value)}
            fullWidth
            multiline
            minRows={3}
            size="small"
            variant="outlined"
            placeholder={"Você é um atendente educado.\nResponda sempre em português do Brasil.\nSeja claro e objetivo."}
          />
          <Typography style={dica}>
            Instruções fixas de como a IA deve se comportar.
          </Typography>
        </Box>

        <Box style={caixa}>
          <Typography style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
            O que a IA pode entender
          </Typography>
          <FormControlLabel
            control={<Switch checked={entenderImagem} onChange={(e) => setEntenderImagem(e.target.checked)} color="primary" />}
            label={<span style={{ fontSize: 13 }}>Entender imagem</span>}
          />
          <FormControlLabel
            control={<Switch checked={entenderPdf} onChange={(e) => setEntenderPdf(e.target.checked)} color="primary" />}
            label={<span style={{ fontSize: 13 }}>Entender PDF</span>}
          />
          <FormControlLabel
            control={<Switch checked={entenderAudio} onChange={(e) => setEntenderAudio(e.target.checked)} color="primary" />}
            label={<span style={{ fontSize: 13 }}>Entender áudio</span>}
          />
          <Typography style={dica}>
            A IA lê a mídia que o cliente enviou. <b>Áudio</b> é transcrito antes (hoje só
            com chave da OpenAI). Essas opções consomem mais tokens.
          </Typography>

          <Box
            style={{
              marginTop: 10,
              border: "1px solid #fdba74",
              background: "#fff7ed",
              borderRadius: 8,
              padding: 10,
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={identificarComprovante}
                  onChange={(e) => setIdentificarComprovante(e.target.checked)}
                  color="primary"
                />
              }
              label={<span style={{ fontSize: 13, fontWeight: 600, color: "#9a3412" }}>Identificar comprovante</span>}
            />
            <Typography style={{ ...dica, color: "#9a3412" }}>
              Analisa a imagem ou PDF enviado e extrai os dados do pagamento (valor, data,
              pagador e se parece válido). O resultado fica na variável escolhida acima.
            </Typography>
          </Box>
        </Box>

        <Box style={caixa}>
          <Typography style={{ fontSize: 13, fontWeight: 600 }}>
            Condicionais inteligentes (até 10)
          </Typography>
          <Typography style={dica}>
            A IA lê a resposta do cliente, classifica e o fluxo segue pela saída
            correspondente. A ordem é a prioridade.
          </Typography>

          {smartConditions.map((c, i) => (
            <Box
              key={i}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: 10,
                marginTop: 10,
              }}
            >
              <Box style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
                <Typography style={{ fontSize: 12, color: "#6b7280", flex: 1 }}>
                  Prioridade {i + 1}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => setSmartConditions((o) => o.filter((_, x) => x !== i))}
                >
                  <Delete fontSize="small" style={{ color: "#dc2626" }} />
                </IconButton>
              </Box>
              <TextField
                label="Quando acontecer isso"
                value={c.prompt || ""}
                onChange={(e) =>
                  setSmartConditions((o) =>
                    o.map((x, idx) => (idx === i ? { ...x, prompt: e.target.value.slice(0, 200) } : x))
                  )
                }
                fullWidth
                size="small"
                variant="outlined"
                multiline
                minRows={2}
                placeholder="Ex: O cliente demonstrou interesse em comprar"
                helperText={`${(c.prompt || "").length}/200`}
              />
              <TextField
                label="Nome da saída"
                value={c.output || ""}
                onChange={(e) =>
                  setSmartConditions((o) =>
                    o.map((x, idx) => (idx === i ? { ...x, output: e.target.value } : x))
                  )
                }
                fullWidth
                size="small"
                variant="outlined"
                style={{ marginTop: 8 }}
                placeholder="Ex: interessado"
                helperText="Aparece como saída no bloco para você ligar o próximo passo"
              />
            </Box>
          ))}

          {smartConditions.length < 10 && (
            <Button
              size="small"
              startIcon={<Add />}
              onClick={() => setSmartConditions((o) => [...o, { prompt: "", output: "" }])}
              style={{ textTransform: "none", marginTop: 10 }}
            >
              Adicionar condicional
            </Button>
          )}

          {smartConditions.length > 0 && (
            <Box style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid #eef0f2" }}>
              <Typography style={{ fontSize: 13, fontWeight: 600 }}>Saída padrão</Typography>
              <Typography style={dica}>
                Quando nenhuma condição for atendida, o fluxo segue por aqui e a IA usa o
                prompt de comportamento acima para gerar a resposta.
              </Typography>
              <TextField
                label="Nome da saída padrão"
                value={defaultOutput}
                onChange={(e) => setDefaultOutput(e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
                style={{ marginTop: 8 }}
                placeholder="Ex: padrao"
                error={!String(defaultOutput).trim()}
                helperText={
                  !String(defaultOutput).trim()
                    ? "Preencha o nome da saída padrão."
                    : "A classificação escolhida fica em {{ai.classificacao}}."
                }
              />
            </Box>
          )}
        </Box>

        <Box style={caixa}>
          <FormControlLabel
            control={<Switch checked={keepContext} onChange={(e) => setKeepContext(e.target.checked)} color="primary" />}
            label={<span style={{ fontSize: 13 }}>Manter contexto da conversa</span>}
          />
          {keepContext && (
            <TextField
              label="Últimas mensagens"
              type="number"
              value={contextSize}
              onChange={(e) => setContextSize(e.target.value)}
              size="small"
              variant="outlined"
              inputProps={{ min: 1, max: 20 }}
              style={{ width: 180, marginTop: 8 }}
              helperText="Máximo 20. Mais contexto = mais custo."
            />
          )}
        </Box>

        <Box style={{ background: "#f8fafc", borderRadius: 10, padding: 12 }}>
          <Typography style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
            Como funciona
          </Typography>
          <Typography style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.6 }}>
            Este bloco chama a IA usando a chave do próprio cliente. A resposta é salva
            numa variável e pode ser usada nos blocos seguintes (inclusive numa
            condicional). Se der erro, o fluxo continua e o motivo fica em{" "}
            <b>{"{{ai.error}}"}</b> — assim você pode tratar a falha no próprio fluxo.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAiBlockModal;
